import {cache as cornerstoneCache} from '@cornerstonejs/core';
import React from 'react';
import {createRoot} from 'react-dom/client';

import App from '@/app';

cornerstoneCache.setMaxCacheSize(
	process.env.MAX_CACHE_SIZE !== undefined && process.env.MAX_CACHE_SIZE !== ''
		? Number(process.env.MAX_CACHE_SIZE)
		: 4294967296, // 4 GB
);

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(<App />);
